import {
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import { HiDotsVertical } from "react-icons/hi";
import { DestructiveMenuItem } from "../../../DestructiveMenuItem";
import { useClipboardToast } from "../../../../hooks/useClipboardToast";

export function DataSourceMenuButton({
  canSync,
  isSyncDisabled,
  isEditDisabled,
  isFileImportDisabled,
  isDeleteDisabled,
  onSync,
  onEdit,
  onFileImport,
  onDelete,
  walletAddress,
}: {
  canSync: boolean;
  isSyncDisabled: boolean;
  isEditDisabled: boolean;
  isFileImportDisabled: boolean;
  isDeleteDisabled: boolean;
  onSync: () => void;
  onEdit: () => void;
  onFileImport: () => void;
  onDelete: () => void;
  walletAddress?: string;
}): React.ReactElement {
  const copyWalletAddress = useClipboardToast({
    value: walletAddress,
    toastOptions: {
      title: "Copied wallet address",
    },
  });

  return (
    <Menu>
      <MenuButton
        h="70px"
        p={5}
        as={IconButton}
        aria-label="Options"
        variant="ghost"
        borderRadius="0"
        icon={<HiDotsVertical />}
      />
      <MenuList>
        {canSync && (
          <Tooltip
            shouldWrapChildren
            isDisabled={!isSyncDisabled}
            label="Sync is already in progress."
            placement="left"
          >
            <MenuItem isDisabled={isSyncDisabled} onClick={onSync}>
              Sync
            </MenuItem>
          </Tooltip>
        )}
        <Tooltip
          shouldWrapChildren
          isDisabled={!isEditDisabled}
          label="You can't edit this data source while a sync is in progress."
          placement="left"
        >
          <MenuItem isDisabled={isEditDisabled} onClick={onEdit}>
            Edit
          </MenuItem>
        </Tooltip>
        <Tooltip
          shouldWrapChildren
          isDisabled={!isFileImportDisabled}
          label="You can't import files while a sync is in progress."
          placement="left"
        >
          <MenuItem isDisabled={isFileImportDisabled} onClick={onFileImport}>
            Import files
          </MenuItem>
        </Tooltip>
        {walletAddress && (
          <MenuItem onClick={copyWalletAddress.onCopy}>
            Copy Wallet Address
          </MenuItem>
        )}
        <Tooltip
          shouldWrapChildren
          isDisabled={!isDeleteDisabled}
          label="You can't delete while a sync is in progress."
          placement="left"
        >
          <DestructiveMenuItem isDisabled={isDeleteDisabled} onClick={onDelete}>
            Delete
          </DestructiveMenuItem>
        </Tooltip>
      </MenuList>
    </Menu>
  );
}
